import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'common/components/Icon';
import Typography from 'common/components/Typography';
import Button from 'common/components/Button';

import styles from './ScreeningFailedStep.module.css';

const ScreeningFailedStep = ({ onRetry }) => (
  <div className={styles.body} data-test="screening-failed">
    <div className={styles.errorSection}>
      <div className={styles.errorHeader}>
        <Icon.CrossCircle description="Request failed" />
        <Typography
          tag="span"
          size="base"
          weight="semiBold"
          color="color-neutral-900"
        >
          Request failed
        </Typography>
      </div>
      <Typography tag="p" size="xs" color="color-neutral-500">
        Unfortunately, your wallet address failed our checks. To proceed, please
        provide a different wallet.
      </Typography>
    </div>

    <Button kind="secondary" full onClick={onRetry}>
      <button type="button" data-test="retry-wallet-button">Provide another wallet</button>
    </Button>
  </div>
);

ScreeningFailedStep.propTypes = {
  onRetry: PropTypes.func.isRequired,
};

export default ScreeningFailedStep;
